import React from 'react';
import PCardContainer from '../PCardContainer';
import './PaymentDetail.scss';

function PaymentDetail({
  title = 'Pay anytime via Bank Transfer',
  data = [],
  isDisabled,
}) {
  return (
    <PCardContainer className="payment-detail" isDisabled={isDisabled}>
      <h5>{title}</h5>
      <ul className="payment-detail__dataList">
        {data.map((item, idx) => (
          <li key={`dl-${idx}`}>
            <span>{item?.label}</span>
            <strong>{item?.value}</strong>
          </li>
        ))}
      </ul>
    </PCardContainer>
  );
}

export default PaymentDetail;
